export interface ShipmentImage {
  id: number;
  orderID: number;
  image: string;
}

export const shipmentImageFromResponse = (
  responseData: any,
): ShipmentImage => ({
  id: responseData.id,
  orderID: responseData.order_id,
  image: responseData.image,
});
